import { axios } from "../../helper/axios";
import { LeadsDataConstant } from "./LeadsContant";

const LeadsApi = {};

LeadsApi.getLeadsData = ({
  from_date = "",
  to_date = "",
  search_term,
  page,
  limit,
}) => {
  console.log("page", from_date,to_date);

  let queryParam = "";
//   if (from_date && to_date) {
//     queryParam = `from_date=${from_date}&to_date=${to_date}`;
//   }
//   if (search_term) {
//     queryParam = `search_term=${search_term}`;
//   }

//   if (page) {
//     queryParam += `page=${page}&`;
//   }
//   if (limit) {
//     queryParam += `limit=${limit}&`;
//   }

   
if (from_date !== undefined && from_date !== null) {
  queryParam += `startDate=${from_date}&`;
}
if (to_date !== undefined && to_date !== null) {
  queryParam += `endDate=${to_date}&`;
}
if ( page ) {
  queryParam += `page=${page}&`;
}
if (limit !== undefined && limit !== null) {
  queryParam += `limit=${limit}&`;
}
if (search_term !== undefined && search_term !== null) {
  queryParam += `search_term=${search_term}&`;
}

  
  return axios.get(`${LeadsDataConstant.LEADS_DATA_API}?${queryParam}`);
};



LeadsApi.getbulkLeadsData = ({
   
    limit,
  }) => {
  
    let queryParam = "";
   
    if (limit) {
      queryParam += `limit=${limit}&`;
    }
  
   
    return axios.get(`${LeadsDataConstant.LEADS_DATA_API}?${queryParam}`);
  };
  

export { LeadsApi };
